import { render, staticRenderFns } from "./YellowBucket.vue?vue&type=template&id=c93a349e&scoped=true&"
import script from "./YellowBucket.vue?vue&type=script&lang=js&"
export * from "./YellowBucket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93a349e",
  null
  
)

export default component.exports